import { render, staticRenderFns } from "./ProjectAssignmentReport.vue?vue&type=template&id=61fdd896&"
import script from "./ProjectAssignmentReport.vue?vue&type=script&lang=js&"
export * from "./ProjectAssignmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports